import { PERSIST_REDUX_KEYS } from "../actionTypes";

export const updateSelectedRoute = (payload) => {
    return { type: PERSIST_REDUX_KEYS.SELECTED_ROUTE, payload };
};

export const updatePersistAppInfo = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_APP_INFO, payload };
};

export const updatePersistTermsAndCond = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_TERMS_COND, payload };
};


export const updatePersistAboutUs = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_ABOUT_US, payload };
};

export const updatePersistDynamicFile = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_BZ_DYNAMIC, payload };
};

export const updatePersistDisclaimer = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_DISCLAIMER, payload };
};

export const updatePersistExchangeTime = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_EXCHANGE_TIME, payload };
};

export const updatePersistBrokerInfo = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_BROKER_INFO, payload };
};


export const updatePersistWorldIndicesData = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_WORLD_INDICES_DATA, payload };
};

export const updatePersistIndicesData = (payload) => {
    return { type: PERSIST_REDUX_KEYS.UPDATE_PERSIST_INDICES_DATA, payload };
};